import { Component, computed, input } from '@angular/core';

// a general avatar-like display component
@Component({
  selector: 'rcp-avatar',
  styleUrls: ['./avatar.component.scss'],
  template: `
    <div
      class="avatar"
      [class.no-src]="!backgroundImage()"
      [style.background-image]="backgroundImage()"
      [class]="size()"
      [class.rounded]="rounded()"
      [class.active]="active()"
    >
      <ng-content></ng-content>
    </div>
  `,
})
export class AvatarComponent {
  readonly src = input<string | null>();
  readonly size = input<'small' | 'medium' | 'large'>('small');
  readonly rounded = input<boolean>();
  readonly active = input<boolean>();

  readonly backgroundImage = computed(() => (this.src() ? `url(${this.src()})` : undefined));
}
